import formIdMixin from './formId';
import formInputFieldPropsMixin from './formInputFieldProps';

export default {
  mixins: [formIdMixin, formInputFieldPropsMixin],
};
